const useCostCalculator = () => {

  const getBillingCost = (billingRange, billedTarget) => {
    switch (billedTarget) {
      case 'citizen':
        return parseFloat(billingRange.cost)
      case 'company':
        return parseFloat(billingRange.companyCost) || parseFloat(billingRange.cost)
      case 'coOwnership':
        return parseFloat(billingRange.coOwnershipCost) || parseFloat(billingRange.cost)
      default:
        return parseFloat(billingRange.cost)
    }
  }

  const calculateCost = (quantite, billingsList, billedTarget) => {
    let billedUnits = 0
    let cost = 0
    billingsList.map(billing => {
      const myCost = getBillingCost(billing, billedTarget)
      if (billedUnits < quantite) {
        let unitsCost = 0
        if (!billing.min && billing.max) {
          if (quantite <= billing.max) {
            unitsCost += myCost * quantite;
            cost += unitsCost
            billedUnits = quantite
          } else {
            unitsCost = billing.max * myCost
            cost += unitsCost
            billedUnits += billing.max
          }
        }
        if (billing.min && !billing.max && quantite >= billing.min) {
          const nbUnits = quantite - billedUnits
          unitsCost = myCost * nbUnits
          cost += unitsCost
          billedUnits = quantite
        }
        if (billing.min && billing.max) {
          let nestsToCount = 0
          if (quantite >= billing.min && quantite <= billing.max) {
            nestsToCount = quantite - billedUnits
          } else {
            nestsToCount = (billing.max - billing.min) + 1
          }

          unitsCost += myCost * nestsToCount
          cost += unitsCost
          billedUnits += nestsToCount
        }
      }
    })

    return cost
  }

  return calculateCost
}

export default useCostCalculator